import React from 'react';
import { connect } from 'react-redux';
import withLoader from 'components/Shared/withLoader';
import { closeImportSouffranceDialog, updateDropZone } from 'store/common/commonActions';
import { fetchQualifications } from 'store/qualification/qualificationActions';
import { fetchSouffrancesTransporteur, clearSouffrancesTransporteur } from 'store/souffranceTransporteur/souffranceTransporteurActions';
import { importSouffrancesTransporteur } from 'store/souffranceTransporteur/souffranceTransporteurActions';


import { useFirstRender } from 'components/Hooks/UseFirstRenderHook';

import { CategorieCodes } from 'constants.js';
import { ImportSouffranceDialogSteps } from './importSouffranceDialogSteps.js';
import ImportSouffranceDialog from './ImportSouffranceDialog';

const ImportSouffranceDialogWithLoader = withLoader(ImportSouffranceDialog);


const ImportSouffranceDialogContainer = ({ open, isLoading, isLoadingFile, isAdding, error, categorieId, importResult, importSouffrancesTransporteur, closeImportSouffranceDialog, updateDropZone, fetchSouffrancesTransporteur, souffrancesTransporteurItems, fetchQualifications, clearSouffrancesTransporteur  }) => {

    const firstRender = useFirstRender();

    const [fichiersIds, setFichiersIds] = React.useState([]);
    const [step, setStep] = React.useState(ImportSouffranceDialogSteps.WaitFile);
    const [souffrancesTransporteur, setSouffrancesTransporteur] = React.useState([]);

    const setInitialState = () => {
        setFichiersIds([]);
        setStep(ImportSouffranceDialogSteps.WaitFile);
        setSouffrancesTransporteur([]);
    };

    // Ouverture de la dialog
    React.useEffect(() => {
        if (open) {
            updateDropZone({ fichiers: [] });
            fetchQualifications();
        }
        else {
            if (!firstRender) {
                clearSouffrancesTransporteur();
                setInitialState();
            }
        }
    }, [open]);


    // Fin de téléchargement du fichier
    React.useEffect(() => {
        if (!isLoadingFile && !firstRender) {
            if (souffrancesTransporteurItems.length > 0) {

                let newSouffrancesTransporteur = souffrancesTransporteurItems.map(x => {
                    var souffrance = x;
                    souffrance.inclure = x.erreur === 0;
                    return souffrance;
                });

                setStep(ImportSouffranceDialogSteps.SetSouffrances);
                setSouffrancesTransporteur(newSouffrancesTransporteur);
            }
            else {
                setInitialState();
            }
        }   
    }, [isLoadingFile, souffrancesTransporteurItems]);

    React.useEffect(() => {
        if (isAdding) {
            setStep(ImportSouffranceDialogSteps.WaitImport);
        } else {
            if (!firstRender) {
                setStep(ImportSouffranceDialogSteps.ImportResult);
            }
        }
    }, [isAdding]);


    const handleClickSave = () => {
        importSouffrancesTransporteur(souffrancesTransporteur);
    };

    const handleClickCancel = () => {
        closeImportSouffranceDialog();
        updateDropZone({fichiers: []});
    };

    const handleChange = (e) => {
        if (e.target.name === "fichiersIds") {

            setFichiersIds(e.target.value);
            if (e.target.value.length) {
                fetchSouffrancesTransporteur(e.target.value[0]);
            }
        }
    };


    const handleChangeQualification = (event, ligne) => {

        const newArray = [...souffrancesTransporteur];

        newArray[ligne].qualificationId = event.target.value;

        setSouffrancesTransporteur(newArray);
    };


    const handleChangeInclure = (event, ligne) => {

        const newArray = [...souffrancesTransporteur];

        newArray[ligne].inclure = !souffrancesTransporteur[ligne].inclure;

        setSouffrancesTransporteur(newArray);
    };


    if (open !== true) return null;

    // On ne peut sauvegarder si une souffrance inclus dans l'import n'a pas de qualification
    //  ou si le transporteur n'est pas défini
    let sauvegardable = (
        (souffrancesTransporteur.length > 0) &&
        (souffrancesTransporteur.find(x => x.qualificationId === 0 && x.inclure) === undefined)
    );

    return (
        <ImportSouffranceDialogWithLoader
            isLoading={isLoading}
            onClickSave={handleClickSave}
            onClickCancel={handleClickCancel}
            onChange={handleChange}
            onChangeQualification={handleChangeQualification}
            onChangeInclure={handleChangeInclure}
            isAdding={false}
            sauvegardable={sauvegardable}
            souffrancesTransporteur={souffrancesTransporteur}
            step={step}
            importResult={importResult}
            categorieId={categorieId}
            error={error}
        />
    );
};



const mapStateToProps = state => ({
    open: state.common.importSouffranceDialogOpen,
    isLoading: state.qualification.qualifications.isLoading,
    isAdding: state.souffrancesTransporteur.isAdding,
    isLoadingFile: state.souffrancesTransporteur.isLoading,
    souffrancesTransporteurItems: state.souffrancesTransporteur.items,
    error: state.souffrancesTransporteur.error,
    categorieId: state.qualification.qualifications.items.find(x => x.categorieCode === CategorieCodes.SouffranceTransporteur) ? state.qualification.qualifications.items.find(x => x.categorieCode === CategorieCodes.SouffranceTransporteur).categorieId : 0,
    importResult: state.souffrancesTransporteur.importResult
});

const mapDispatchToProps = dispatch => ({
    closeImportSouffranceDialog: () => dispatch(closeImportSouffranceDialog()),
    fetchSouffrancesTransporteur: (fichierId) => dispatch(fetchSouffrancesTransporteur(fichierId)),
    importSouffrancesTransporteur: (souffrancesTransporteur) => dispatch(importSouffrancesTransporteur(souffrancesTransporteur)),
    clearSouffrancesTransporteur: () => dispatch(clearSouffrancesTransporteur()),    
    fetchQualifications: () => dispatch(fetchQualifications(false)),
    updateDropZone: (dropZone) => dispatch(updateDropZone(dropZone))
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportSouffranceDialogContainer);